export function roles(state) {
  return state.roles;
}
export function meta(state) {
  return state.meta;
}
export function role(state) {
  return state.role;
}